import { LinkContainer } from 'react-router-bootstrap';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import styled from 'styled-components';
import Stack from 'react-bootstrap/Stack';
import SlideCarousel from '../components/SlideCarousel';
import Ratio from 'react-bootstrap/Ratio';

const StyledSection = styled.section`
font-family: 'Roboto';

max-width: 1320px;
margin: 60px auto 0px auto;
padding: 12px 0px;
.header-card {
  color: #ffffff;
}
`

function OurAreaPage() {
  return (
    <>     
    <StyledSection>
      <Container>
        <Row>          
          <Col className='py-2'>    
            <Card bg='trans-white'>
              <Card.Body>
                <Card.Title>
                  <h1>
                    <a href='/florida-community/canterbury-lake-estates' title='Learn more about Canterbury Lake Estates' aria-label='Learn more about Canterbury Lake Estates'>
                      Canterbury Lake Estates
                    </a>
                  </h1>
                </Card.Title>             
                <SlideCarousel className='featured-carousel' slideType='community' queryValue='canterbury-lake-estates' count={4} controls={false} cardWrapper={true} bg='trans-white' />              
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className='py-2'>      
            <Card bg='trans-white'>
              <Card.Body>
                <Card.Title>
                  <h1>
                    <a href='/homes-for-sale/citrus-hills' title='Homes for sale Citrus Hills' aria-label='Homes for sale Citrus Hills'>
                      Citrus Hills
                    </a>
                  </h1>
                </Card.Title>      
                <SlideCarousel className='featured-carousel' slideType='community' queryValue='citrus-hills' count={4} controls={false} cardWrapper={true} bg='trans-white' />              
              </Card.Body>
            </Card>
          </Col>
        </Row>   
        <Row>
          <Col className='py-2'>     
            <Card bg='trans-white'>
              <Card.Body>
                <Card.Title>
                  <h1>
                    <a href='/homes-for-sale/citrus-springs' title='Homes for sale Citrus Springs' aria-label='Homes for sale Citrus Springs'>
                      Citrus Springs
                    </a>
                  </h1>
                </Card.Title>       
                <SlideCarousel className='featured-carousel' slideType='community' queryValue='citrus-springs' count={4} controls={false} cardWrapper={true} bg='trans-white' />              
              </Card.Body>
            </Card>
          </Col>
        </Row>         
        <Row>
          <Col className='py-2'>    
            <Card bg='trans-white'>
              <Card.Body>
                <Card.Title>
                  <h1>
                    <a href='/florida-community/crystal-oaks' title='Learn more about Crystal Oaks' aria-label='Learn more about Crystal Oaks'>
                      Crystal Oaks
                    </a>
                  </h1>
                </Card.Title>   
                <SlideCarousel className='featured-carousel' slideType='community' queryValue='crystal-oaks' count={4} controls={false} cardWrapper={true} bg='trans-white' />              
              </Card.Body>
            </Card>
          </Col>
        </Row>            
        <Row>
          <Col className='py-2'>      
            <Card bg='trans-white'>
              <Card.Body>
                <Card.Title>
                  <h1>
                    <a href='/homes-for-sale/meadowcrest' title='Homes for sale Meadowcrest' aria-label='Homes for sale Meadowcrest'>
                      Meadowcrest
                    </a>
                  </h1>
                </Card.Title>      
                <SlideCarousel className='featured-carousel' slideType='community' queryValue='meadowcrest' count={4} controls={false} cardWrapper={true} bg='trans-white' />              
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className='py-2'>     
            <Card bg='trans-white'>
              <Card.Body>
                <Card.Title>
                  <h1>
                    <a href='/florida-community/moorings-at-point-o-woods' title='Learn more about Moorings at Point O Woods' aria-label='Learn more about Moorings at Point O Woods'>
                      Moorings at Point O Woods
                    </a>
                  </h1>
                </Card.Title>       
                <SlideCarousel className='featured-carousel' slideType='community' queryValue='moorings-at-point-o-woods' count={4} controls={false} cardWrapper={true} bg='trans-white' />              
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className='py-2'>       
            <Card bg='trans-white'>
              <Card.Body>
                <Card.Title>
                  <h1>
                    <a href='/florida-community/pine-ridge' title='Learn more about Pine Ridge' aria-label='Learn more about Pine Ridge'>
                      Pine Ridge
                    </a>
                  </h1>
                </Card.Title>     
                <SlideCarousel className='featured-carousel' slideType='community' queryValue='pine-ridge' count={4} controls={false} cardWrapper={true} bg='trans-white' />              
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className='py-2'>       
            <Card bg='trans-white'>
              <Card.Body>
                <Card.Title>
                  <h1>
                    <a href='/florida-community/terra-vista' title='Learn more about Terra Vista' aria-label='Learn more about Terra Vista'>
                      Terra Vista
                    </a>
                  </h1>
                </Card.Title>     
                <SlideCarousel className='featured-carousel' slideType='community' queryValue='Citrus-Hills---Terra-Vista' count={4} controls={false} cardWrapper={true} bg='trans-white' />              
              </Card.Body>
            </Card>
          </Col>
        </Row>        
        <Row>
          <Col className='py-2'>     
            <Card bg='trans-white'>
              <Card.Body>
                <Card.Title>
                  <h1>
                    <a href='/florida-community/tradewinds-resort' title='Learn more about Tradewinds Resort' aria-label='Learn more about Tradewinds Resort'>
                      Tradewinds Resort
                    </a>
                  </h1>
                </Card.Title>       
                <SlideCarousel className='featured-carousel' slideType='community' queryValue='homosassa-tradewinds-condos' count={4} controls={false} cardWrapper={true} bg='trans-white' />              
              </Card.Body>
            </Card>
          </Col>
        </Row>                    
      </Container>
    </StyledSection>
    </>
  );
}

  
  export default OurAreaPage;